
import MDTypography from "components/MDTypography";

export default function CTLDateShow ({ value }) {

  if (!Array.isArray(value) || value.length < 3) return null;

  const [year, month, day, hour = 0, minute = 0, second = 0] = value;
  const date = new Date(year, month - 1, day, hour, minute, second);


  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      {date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })}
    </MDTypography>
  );
}

CTLDateShow.defaultProps = {
  suffix: "",
};
